import React from 'react';

import Select from 'react-select';

import currency from '@/data/currency';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectCurrency: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={currency.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={currency}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectCurrency;
